import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Hizmetler', path: '/hizmetler' },
    { name: 'Referanslar', path: '/referanslar' },
    { name: 'İletişim', path: '/iletisim' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-md`}
    >
      <nav className="w-full px-6 py-2 md:py-4">
        <div className="container mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/3024b39c21788ca1106345c15c1e435c.png"
              alt="İzmir Tadilat Firması Logo"
              className="h-12 md:h-16 lg:h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-all duration-300 relative group whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'text-wood-dark'
                    : 'text-wood hover:text-wood-dark'
                }`}
              >
                {item.name}
                <span
                  className={`absolute bottom-0 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full bg-wood-dark`}
                ></span>
              </Link>
            ))}
          </div>

          {/* Contact Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:05421138110"
              className="flex items-center space-x-2 bg-wood hover:bg-wood-dark text-white px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="font-medium text-sm">0542 113 81 10</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer text-wood-dark"
            aria-label="Menü"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3 bg-white rounded-2xl p-6 shadow-xl">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === item.path ? 'text-wood-dark' : 'text-wood hover:text-wood-dark'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href="tel:05421138110"
              className="flex items-center justify-center space-x-2 bg-wood text-white px-6 py-3 rounded-full whitespace-nowrap cursor-pointer mt-4"
            >
              <i className="ri-phone-line"></i>
              <span className="text-sm">0542 113 81 10</span>
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
